export default {
  mesa: "Tisch",
  product: "Produkt",
  quantity: "Menge",
  price: "Preis",
  total: "Konto insgesamt",
  totalPaid: "Ganz bezahlt",
  baseTax: "Steúerbemessungsgrundlage",
  VAT: "MwSt.",
  paymentMethod: "Zahlungsweise",
  pagado: "Ausbezahlt"
};
